import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { API_URL } from "../api/client";
import { assignLocation } from "../shell/location";

/** Where the Accounts login should send the user back to: an in-app path only,
 *  so `return_to` cannot be pointed at another site. */
export function safeReturnTo(raw: string | null): string {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//")) return "/ads";
  return raw;
}

export function loginUrl(returnTo: string): string {
  return `${API_URL}/api/v1/accounts/login?return_to=${encodeURIComponent(returnTo)}`;
}

/** Sign-in is an Accounts screen (docs/08 §5); this route only redirects. */
export function LoginPage() {
  const [params] = useSearchParams();
  const returnTo = safeReturnTo(params.get("return_to"));
  useEffect(() => {
    assignLocation(loginUrl(returnTo));
  }, [returnTo]);
  return (
    <main className="mx-auto max-w-md px-4 py-24 text-center text-slate-600">
      <p>Taking you to Intelibo Accounts to sign in…</p>
      <p className="mt-2 text-sm">
        <a href={loginUrl(returnTo)}>Continue</a> if nothing happens.
      </p>
    </main>
  );
}
